import useClubPortalBranding from "../../hooks/useClubPortalBranding";

/** Подключает фирменный стиль клуба (десктоп / вне AdminAppShell). */
export default function ClubPortalBrandingActivator({ refreshFromApi = true }) {
  useClubPortalBranding("aa", null, refreshFromApi);
  return null;
}
